import React from "react";

import { Facebook, Google, Linkedin } from "./buttons/index.jsx"

const SocialButtons = ({ onSuccess, fullWidth = false }) => {
    const breakpoint = fullWidth ? 'md' : 'xxl';

    return (
        <div className="row social-login mt-5">
            <div className={`col-${breakpoint}-4`}>
                <Linkedin onSuccess={onSuccess} />
            </div>
      {/**
            <div className={`col-${breakpoint}-4 px-0 px-${breakpoint}-2 pt-2 pt-${breakpoint}-0`}>
                <Facebook onSuccess={onSuccess} />
            </div>
            <div className={`col-${breakpoint}-4 pt-2 pt-${breakpoint}-0`}>
                <Google onSuccess={onSuccess} />
            </div>
            */}
        </div>
    )
};

export default SocialButtons;
